/**
 * 审批列表（通用，供三个 tab 复用）。
 */

import Spinner from '../../components/Spinner';
import EmptyState from '../../components/EmptyState';
import ApprovalCard from './ApprovalCard';
import type { ApprovalInstanceInfo } from '@atlaspm/shared';
import type { ReactNode } from 'react';

export interface TodoListProps {
  items: ApprovalInstanceInfo[];
  isLoading: boolean;
  isError: boolean;
  error: Error | null;
  emptyTitle?: string;
  emptyHint?: ReactNode;
  /** 是否显示同意/退回按钮（仅「待我审批」） */
  actionabled?: boolean;
  /** ⭐ P8.20 点击卡片查看对应任务详情 */
  onOpen?(item: ApprovalInstanceInfo): void;
  onApprove?(item: ApprovalInstanceInfo): void;
  onReject?(item: ApprovalInstanceInfo): void;
  /** ⭐ P6.16 终止已超时(EXPIRED)的审批 */
  onTerminate?(item: ApprovalInstanceInfo): void;
}

export default function TodoList({
  items,
  isLoading,
  isError,
  error,
  emptyTitle = '暂无待办',
  emptyHint,
  actionabled,
  onOpen,
  onApprove,
  onReject,
  onTerminate,
}: TodoListProps) {
  if (isLoading) return <Spinner label="加载审批列表…" />;
  if (isError) {
    return (
      <EmptyState
        icon="⚠"
        title="审批列表加载失败"
        hint={error?.message ?? '请稍后重试'}
      />
    );
  }
  if (items.length === 0) {
    return <EmptyState icon="☷" title={emptyTitle} hint={emptyHint} />;
  }

  return (
    <div className="appr-list">
      {items.map((item) => (
        <ApprovalCard
          key={item.id}
          item={item}
          actionabled={actionabled}
          onOpen={onOpen}
          onApprove={onApprove}
          onReject={onReject}
          onTerminate={onTerminate}
        />
      ))}
    </div>
  );
}
